module.exports = __webpack_public_path__ + "img/p-post.2b7fa05f.png";